import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
function LegalModal({
  title,
  onClose,
  children
}: {
  title: string;
  onClose: () => void;
  children: React.ReactNode;
}) {
  return <AnimatePresence data-id="element-106">
      <motion.div className="fixed inset-0 z-50 flex items-center justify-center p-4" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} data-id="element-107">
        <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} data-id="element-108" />
        <motion.div className="relative bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden" initial={{
        scale: 0.95,
        opacity: 0,
        y: 20
      }} animate={{
        scale: 1,
        opacity: 1,
        y: 0
      }} exit={{
        scale: 0.95,
        opacity: 0,
        y: 20
      }} transition={{
        type: 'spring',
        duration: 0.4
      }} data-id="element-109">
          <div className="flex items-center justify-between p-6 border-b border-gray-100" data-id="element-110">
            <h2 className="text-xl font-bold text-forest" data-id="element-111">{title}</h2>
            <button onClick={onClose} className="p-2 rounded-full hover:bg-gray-100 transition-colors" aria-label="Cerrar" data-id="element-112">
              <XIcon className="w-5 h-5 text-gray-500" data-id="element-113" />
            </button>
          </div>
          <div className="p-6 overflow-y-auto max-h-[calc(80vh-80px)] text-sm text-gray-700 leading-relaxed space-y-4" data-id="element-114">
            {children}
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>;
}
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="bg-forest text-mint/60 py-12 text-center text-sm" data-id="element-115">
        <div className="container mx-auto px-6" data-id="element-116">
          <p className="mb-4" data-id="element-117">
            © {new Date().getFullYear()} Protocolo SOS 72H. Todos los derechos
            reservados.
          </p>
          <div className="flex items-center justify-center gap-4 mb-4" data-id="element-118">
            <button onClick={() => setShowPrivacy(true)} className="underline underline-offset-2 hover:text-mint transition-colors" data-id="element-119">
              Política de Privacidad
            </button>
            <span className="opacity-40" data-id="element-120">|</span>
            <button onClick={() => setShowTerms(true)} className="underline underline-offset-2 hover:text-mint transition-colors" data-id="element-121">
              Términos de Servicio
            </button>
          </div>
          <p className="max-w-2xl mx-auto opacity-70 text-xs leading-relaxed" data-id="element-122">
            Descargo de responsabilidad: La información proporcionada en este
            sitio web y en el libro electrónico tiene fines educativos
            únicamente y no pretende sustituir el consejo médico profesional, el
            diagnóstico o el tratamiento. Siempre busque el consejo de su médico
            u otro proveedor de salud calificado con cualquier pregunta que
            pueda tener sobre una condición médica.
          </p>
        </div>
      </footer>

      {showPrivacy && <LegalModal title="Política de Privacidad" onClose={() => setShowPrivacy(false)} data-id="element-123">
          <p data-id="element-124">
            <strong data-id="element-125">Última actualización:</strong> Abril 2026
          </p>
          <p data-id="element-126">
            En Protocolo SOS 72H, nos comprometemos a proteger tu privacidad.
            Esta política describe cómo recopilamos, usamos y protegemos tu
            información personal.
          </p>
          <h3 className="font-semibold text-forest text-base mt-2" data-id="element-127">
            1. Información que Recopilamos
          </h3>
          <p data-id="element-128">
            Recopilamos información que nos proporcionas directamente, como tu
            nombre y dirección de correo electrónico al realizar una compra.
            También podemos recopilar información de uso del sitio web de forma
            anónima para mejorar nuestros servicios.
          </p>
          <h3 className="font-semibold text-forest text-base mt-2" data-id="element-129">
            2. Uso de la Información
          </h3>
          <p data-id="element-130">
            Utilizamos tu información para procesar tu compra, enviarte el
            producto digital adquirido, y comunicarnos contigo sobre
            actualizaciones relevantes. No vendemos ni compartimos tu
            información personal con terceros con fines de marketing.
          </p>
          <h3 className="font-semibold text-forest text-base mt-2" data-id="element-131">
            3. Protección de Datos
          </h3>
          <p data-id="element-132">
            Implementamos medidas de seguridad técnicas y organizativas para
            proteger tu información personal contra el acceso no autorizado, la
            alteración, divulgación o destrucción.
          </p>
          <h3 className="font-semibold text-forest text-base mt-2" data-id="element-133">
            4. Cookies
          </h3>
          <p data-id="element-134">
            Nuestro sitio web puede utilizar cookies para mejorar tu experiencia
            de navegación. Puedes configurar tu navegador para rechazar cookies,
            aunque esto podría afectar la funcionalidad del sitio.
          </p>
          <h3 className="font-semibold text-forest text-base mt-2" data-id="element-135">
            5. Tus Derechos
          </h3>
          <p data-id="element-136">
            Tienes derecho a acceder, rectificar o eliminar tu información
            personal en cualquier momento. Para ejercer estos derechos,
            contáctanos a través de nuestro correo electrónico de soporte.
          </p>
          <h3 className="font-semibold text-forest text-base mt-2" data-id="element-137">
            6. Contacto
          </h3>
          <p data-id="element-138">
            Si tienes preguntas sobre esta política de privacidad, puedes
            contactarnos a través de nuestro correo electrónico de soporte.
          </p>
        </LegalModal>}

      {showTerms && <LegalModal title="Términos de Servicio" onClose={() => setShowTerms(false)} data-id="element-139">
          <p data-id="element-140">
            <strong data-id="element-141">Última actualización:</strong> Abril 2026
          </p>
          <p data-id="element-142">
            Al acceder y utilizar este sitio web y adquirir el producto
            Protocolo SOS 72H, aceptas los siguientes términos y condiciones.
          </p>
          <h3 className="font-semibold text-forest text-base mt-2" data-id="element-143">
            1. Producto Digital
          </h3>
          <p data-id="element-144">
            Protocolo SOS 72H es un producto digital (libro electrónico en
            formato PDF) que se entrega de forma instantánea tras la compra. Al
            ser un producto digital descargable, no se aceptan devoluciones una
            vez realizada la descarga.
          </p>
          <h3 className="font-semibold text-forest text-base mt-2" data-id="element-145">
            2. Uso Personal
          </h3>
          <p data-id="element-146">
            El contenido adquirido es para uso personal únicamente. Queda
            prohibida la reproducción, distribución, modificación o reventa del
            material sin autorización expresa por escrito.
          </p>
          <h3 className="font-semibold text-forest text-base mt-2" data-id="element-147">
            3. Descargo de Responsabilidad Médica
          </h3>
          <p data-id="element-148">
            El contenido del Protocolo SOS 72H tiene fines educativos e
            informativos únicamente. No constituye consejo médico profesional ni
            sustituye la consulta con un profesional de la salud. Siempre
            consulta a tu médico antes de realizar cambios en tu dieta o estilo
            de vida.
          </p>
          <h3 className="font-semibold text-forest text-base mt-2" data-id="element-149">
            4. Resultados
          </h3>
          <p data-id="element-150">
            Los resultados pueden variar de persona a persona. No garantizamos
            resultados específicos, ya que estos dependen de factores
            individuales como el estado de salud, la adherencia al protocolo y
            otros factores personales.
          </p>
          <h3 className="font-semibold text-forest text-base mt-2" data-id="element-151">
            5. Propiedad Intelectual
          </h3>
          <p data-id="element-152">
            Todo el contenido de este sitio web y del producto digital,
            incluyendo textos, imágenes, diseño y logotipos, está protegido por
            derechos de autor y es propiedad de Protocolo SOS 72H.
          </p>
          <h3 className="font-semibold text-forest text-base mt-2" data-id="element-153">
            6. Modificaciones
          </h3>
          <p data-id="element-154">
            Nos reservamos el derecho de modificar estos términos en cualquier
            momento. Las modificaciones entrarán en vigor inmediatamente después
            de su publicación en el sitio web.
          </p>
        </LegalModal>}
    </>;
}